import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: HomeView
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta:{
      requiresAuth:false,
    },
    component: () => import('../views/aboutUsView.vue')
  },
  {
    path: '/doubt',
    name: 'doubt',
    meta:{
      requiresAuth:false,
    },
    component: () => import('../views/doubtView.vue')
  },

  {
    path: '/contactUs',
    name: 'contactUs',
    meta:{
      requiresAuth:false,
    },
    component: () => import('../views/contactUsView.vue')
  }
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
